import { Nillable } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { AdminOrderItemAttribute } from './admin-order-item-attribute';
import { OrderItemRefundSummary, ProductType } from '@web/shared/module/shop';
import { AdminOrderItemComponentGroup } from './admin-order-item-component-group';

export class AdminOrderItem {
  public constructor(
    private readonly data: {
      name: string;
      subName?: Nillable<string>;
      slug?: Nillable<string>;
      type: ProductType;
      quantity: number;
      unitPrice: number;
      price: number;
      featuredFile?: Nillable<Multimedia>;
      attributes: AdminOrderItemAttribute[];
      componentGroups: AdminOrderItemComponentGroup[];
      refundSummary?: Nillable<OrderItemRefundSummary>;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get subName(): Nillable<string> {
    return this.data.subName;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }

  public get type(): ProductType {
    return this.data.type;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get unitPrice(): number {
    return this.data.unitPrice;
  }

  public get price(): number {
    return this.data.price;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }

  public get attributes(): AdminOrderItemAttribute[] {
    return this.data.attributes;
  }

  public get componentGroups(): AdminOrderItemComponentGroup[] {
    return this.data.componentGroups;
  }

  public get refundSummary(): Nillable<OrderItemRefundSummary> {
    return this.data.refundSummary;
  }
}
